<template>
  <div class="pb-10">
    <!-- Date Range Filter (sticky) -->
    <DateRangeFilter />

    <div class="max-w-[1400px] mx-auto px-4 pt-6 space-y-8">
      <!-- Header -->
      <h1 class="text-lg font-semibold text-gray-900">Tableau de bord</h1>

      <!-- Vue d'ensemble -->
      <section>
        <h2 class="section-title">Vue d'ensemble</h2>
        <KpiSalesCard />
      </section>

      <!-- Finances -->
      <section>
        <h2 class="section-title">Finances</h2>
        <div class="space-y-4">
          <KpiRevenueCard />
          <KpiAccountingCard />
        </div>
      </section>

      <!-- Tendances -->
      <section>
        <h2 class="section-title">Tendances</h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <ChartSalesTrend />
          <ChartRevenueTrend />
        </div>
      </section>

      <!-- Repartitions -->
      <section>
        <h2 class="section-title">Repartitions</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          <ChartSalesByStatus />
          <ChartSalesByPaymentMethod />
          <ChartSalesByType />
        </div>
      </section>

      <!-- Analyse -->
      <section>
        <h2 class="section-title">Analyse</h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <ChartRevenueByUser />
          <ChartHourlySales />
        </div>
      </section>

      <!-- Classements -->
      <section>
        <h2 class="section-title">Classements</h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <TableTopProducts />
          <TableTopCustomers />
        </div>
      </section>

      <!-- Activite recente -->
      <section>
        <h2 class="section-title">Activite recente</h2>
        <TableRecentSales />
      </section>

      <!-- Alertes stock -->
      <section>
        <h2 class="section-title">Alertes stock</h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <TableLowStock />
          <TableOutOfStock />
        </div>
      </section>

      <!-- Equipe & Facturation -->
      <section>
        <h2 class="section-title">Equipe & Facturation</h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <TableUserPerformance />
          <TableUnpaidInvoices />
        </div>
      </section>

      <!-- Clients & Produits -->
      <section>
        <h2 class="section-title">Clients & Produits</h2>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <ChartCustomerActivity />
          <ChartProductsByCategory />
        </div>
      </section>

      <!-- Clients & Facturation KPIs -->
      <section>
        <h2 class="section-title">Clients & Facturation</h2>
        <div class="grid grid-cols-1 lg:grid-cols-1 gap-5">
          <KpiCustomersCard />
          <KpiInvoicingCard />
        </div>
      </section>

      <!-- Inventaire -->
      <section>
        <h2 class="section-title">Inventaire</h2>
        <KpiProductsCard />
      </section>
    </div>
  </div>
</template>

<script setup>
import { provideDateRange } from '@/composables/useDateRange'

// Provide date range to all children
provideDateRange()

// Date Range Filter
import DateRangeFilter from '@/components/dashboard/DateRangeFilter.vue'

// KPI Cards
import KpiSalesCard from '@/components/dashboard/KpiSalesCard.vue'
import KpiRevenueCard from '@/components/dashboard/KpiRevenueCard.vue'
import KpiCustomersCard from '@/components/dashboard/KpiCustomersCard.vue'
import KpiProductsCard from '@/components/dashboard/KpiProductsCard.vue'
import KpiAccountingCard from '@/components/dashboard/KpiAccountingCard.vue'
import KpiInvoicingCard from '@/components/dashboard/KpiInvoicingCard.vue'

// Charts
import ChartSalesTrend from '@/components/dashboard/ChartSalesTrend.vue'
import ChartRevenueTrend from '@/components/dashboard/ChartRevenueTrend.vue'
import ChartCustomerActivity from '@/components/dashboard/ChartCustomerActivity.vue'
import ChartSalesByStatus from '@/components/dashboard/ChartSalesByStatus.vue'
import ChartSalesByPaymentMethod from '@/components/dashboard/ChartSalesByPaymentMethod.vue'
import ChartSalesByType from '@/components/dashboard/ChartSalesByType.vue'
import ChartProductsByCategory from '@/components/dashboard/ChartProductsByCategory.vue'
import ChartRevenueByUser from '@/components/dashboard/ChartRevenueByUser.vue'
import ChartHourlySales from '@/components/dashboard/ChartHourlySales.vue'

// Tables
import TableTopProducts from '@/components/dashboard/TableTopProducts.vue'
import TableTopCustomers from '@/components/dashboard/TableTopCustomers.vue'
import TableRecentSales from '@/components/dashboard/TableRecentSales.vue'
import TableLowStock from '@/components/dashboard/TableLowStock.vue'
import TableOutOfStock from '@/components/dashboard/TableOutOfStock.vue'
import TableUserPerformance from '@/components/dashboard/TableUserPerformance.vue'
import TableUnpaidInvoices from '@/components/dashboard/TableUnpaidInvoices.vue'
</script>

<style scoped>
.section-title {
  @apply text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3;
}
</style>
